import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@fiverr/fit';
import '@fiverr/globals';
import { GigCardShell, Media, Title, SellerInfo, SellerLevel, Username, ListViewInfo, SellerCountry, SellerResponseTime, Price, GigBadges, Rating, CollectGig } from '../shared';
import { getCurrency, adaptGigData, getGigAssets, isRisingTalent, gigCardExperiments } from '../utils';
import './style.scss';

const ListViewItem = ({ gig, user, updateCollections, context = {} }) => {
    const inExperiment = gigCardExperiments(context.abTests),
        userId = user && user.userId || null,
        risingTalent = isRisingTalent(gig.type),
        limitDisplayedRatings = inExperiment('RATINGS_THRESHOLD_ONE_HUNDRED'),
        showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate,
        shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent;

    adaptGigData(gig, { context });

    return (
        <GigCardShell key={gig.gig_id} type="list-view-card" gigId={gig.gig_id}>
            <div className="flex-row">
                <div className="col-media">
                    <a href={gig.gig_url} className="js-gig-card-imp-data">
                        <Media assets={getGigAssets(gig)} gigId={gig.gig_id} userId={userId}/>
                    </a>
                </div>
                <div className="col-gig-info">
                    <Title gigUrl={gig.gig_url} caption={gig.iwill_title}/>
                    <div className="desktop">
                        <SellerInfo>
                            {gig.is_seller_online && <span className="is-online"></span>}
                            <Avatar src={gig.seller_img}/>
                            <Username name={gig.seller_name} url={gig.seller_url} prefix={i18n.t('general.by')} context={context}/>
                            {!risingTalent && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isNewSeller={gig.is_new_seller}/>}
                            {gig.seller_country_name && <SellerCountry country={gig.seller_country_name} comma={gig.seller_level || gig.is_pro}/>}
                            {gig.seller_avg_response && <SellerResponseTime responseTime={gig.seller_avg_response} comma={true}/>}
                        </SellerInfo>
                        <Price gigUrl={gig.gig_url}
                            price={getCurrency(gig.price_i, true)}
                            showStartingAt={gig.show_starting_at}
                            averagePrice={getCurrency(gig.average_price)}
                            medianPrice={getCurrency(gig.median_price)}/>
                    </div>
                    <div className="rating-badges-container">
                        {shouldRenderRating && <Rating score={gig.rating} gigId={gig.gig_id} votes={gig.rating_count} starSize={16} starCount={1} isPro={gig.is_pro} limitDisplayedRatings={limitDisplayedRatings}/>}
                        <GigBadges featured={gig.is_featured}
                            limitedEdition={gig.is_limited_edition}
                            limitedEditionDeadline={gig.limited_edition_expires_at}
                            qualityChoice={gig.quality_choice}
                            reliable={showHighCompletionRate}
                            availableNow={gig.is_available_now}
                            risingTalent={risingTalent}
                            sellerName={gig.seller_name}
                            pro={gig.is_pro}
                            gigId={gig.gig_id}/>
                    </div>
                    <ListViewInfo platforms={gig.metadata && gig.metadata.platform ? gig.metadata.platform : null}
                        skills={gig.skills}
                        avgDeliveryTime={gig.avg_delivery_time}/>
                    <CollectGig gigId={gig.gig_id} sellerId={gig.seller_id} updateCollections={updateCollections} user={user} showCollMenu={true} icon="fa fa-ellipsis-v"/>
                </div>
            </div>
            <div className="flex-row space-between mobile">
                <SellerInfo>
                    {gig.is_seller_online && <span className="is-online"></span>}
                    <Avatar src={gig.seller_img}/>
                    <Username name={gig.seller_name} url={gig.seller_url} prefix={i18n.t('general.by')} context={context}/>
                    {!risingTalent && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isLimitedEdition={gig.is_limited_edition} isNewSeller={gig.is_new_seller}/>}
                </SellerInfo>

                <Price gigUrl={gig.gig_url}
                    price={getCurrency(gig.price_i, true)}
                    showStartingAt={gig.show_starting_at}
                    isLimitedEdition={gig.is_limited_edition}
                    averagePrice={getCurrency(gig.average_price)}
                    medianPrice={getCurrency(gig.median_price)}/>
            </div>
        </GigCardShell>
    );
};

ListViewItem.propTypes = {
    gig: PropTypes.obj,
    user: PropTypes.obj,
    updateCollections: PropTypes.func,
    context: PropTypes.obj
};

export default ListViewItem;



// WEBPACK FOOTER //
// ./src/list_view_card/ListView.js